// uproot-pdp.js — buy box (Style real x Size cantidad), galeria, accordions, Bundle+Save y reviews
// (Okendo real extraidas: sort + filtro "con fotos" sobre los datos ya cargados). ATC real via
// window.wmcpAddToCart (snippets/wmcp-cart.liquid) -> abre el drawer lateral, nunca redirect a /cart.
(function () {
  var DATA = window.UP_WMCP;
  if (!DATA) return;

  var state = { style: "pro", size: 1 };
  var gallery = document.querySelector("[data-up-gal-main]");
  var thumbs = document.querySelectorAll("[data-up-thumb]");
  var stylePills = document.querySelectorAll("[data-up-style]");
  var sizeCards = document.querySelectorAll("[data-up-size]");
  var priceEl = document.querySelector("[data-up-price]");
  var compareEl = document.querySelector("[data-up-price-compare]");
  var atcBtn = document.querySelector("[data-up-atc]");
  var atcLabel = atcBtn ? atcBtn.querySelector("span") : null;

  function variant() { return DATA.variants[state.style]; }
  function sizeInfo() { return variant().sizes[String(state.size)]; }

  function render() {
    stylePills.forEach(function (el) { el.classList.toggle("active", el.dataset.upStyle === state.style); });
    sizeCards.forEach(function (el) {
      var n = Number(el.dataset.upSize);
      el.classList.toggle("active", n === state.size);
      var info = variant().sizes[String(n)];
      var priceSpan = el.querySelector("[data-up-size-price]");
      var eachSpan = el.querySelector("[data-up-each]");
      var cmpSpan = el.querySelector("[data-up-size-cmp]");
      if (priceSpan) priceSpan.textContent = "$" + info.price.toFixed(2);
      if (eachSpan) eachSpan.textContent = "$" + (Math.floor((info.price / (n * 24)) * 100) / 100).toFixed(2) + " Each + Free Gift";
      if (cmpSpan) { if (info.compare) { cmpSpan.textContent = "$" + info.compare.toFixed(2); cmpSpan.hidden = false; } else cmpSpan.hidden = true; }
    });
    var s = sizeInfo();
    if (priceEl) priceEl.textContent = "$" + s.price.toFixed(2);
    if (compareEl) { if (s.compare) { compareEl.textContent = "$" + s.compare.toFixed(2); compareEl.hidden = false; } else compareEl.hidden = true; }
    if (gallery && variant().image) gallery.src = variant().image;
    if (atcLabel) atcLabel.textContent = "ADD TO CART";
  }
  stylePills.forEach(function (el) { el.addEventListener("click", function () { state.style = el.dataset.upStyle; render(); }); });
  sizeCards.forEach(function (el) { el.addEventListener("click", function () { state.size = Number(el.dataset.upSize); render(); }); });

  // galeria
  var thumbList = Array.prototype.slice.call(thumbs);
  function setThumb(i) {
    var el = thumbList[i]; if (!el || !gallery) return;
    gallery.src = el.src.replace(/width=\d+/, "width=900");
    thumbList.forEach(function (t) { t.classList.remove("active"); });
    el.classList.add("active");
  }
  thumbList.forEach(function (el, i) { el.addEventListener("click", function () { setThumb(i); }); });
  function curThumb() { var i = thumbList.findIndex(function (t) { return t.classList.contains("active"); }); return i < 0 ? 0 : i; }
  var prevBtn = document.querySelector("[data-up-gal-prev]"), nextBtn = document.querySelector("[data-up-gal-next]");
  if (prevBtn) prevBtn.addEventListener("click", function () { setThumb((curThumb() - 1 + thumbList.length) % thumbList.length); });
  if (nextBtn) nextBtn.addEventListener("click", function () { setThumb((curThumb() + 1) % thumbList.length); });

  // ATC principal
  if (atcBtn) {
    atcBtn.addEventListener("click", function () {
      atcBtn.disabled = true;
      var items = [{ id: variant().id, quantity: state.size }];
      (window.wmcpAddToCart ? window.wmcpAddToCart(items) : Promise.reject(new Error("cart not ready")))
        .catch(function (e) { console.error("wmcp ATC error", e); alert(e.message); })
        .then(function () { atcBtn.disabled = false; });
    });
  }

  // "Buy with Shop" y "More payment options": permalink real de Shopify /cart/<variantId>:<qty>
  // (añade la variante/cantidad SELECCIONADA y va directo al checkout) — pedido del director vuelta 4.
  var shopPayBtn = document.querySelector("[data-up-shoppay]");
  if (shopPayBtn) {
    shopPayBtn.addEventListener("click", function () {
      window.location.href = "/cart/" + variant().id + ":" + state.size + "?payment=shop_pay";
    });
  }
  var altPay = document.querySelector("[data-up-atc-alt]");
  if (altPay) {
    altPay.addEventListener("click", function () {
      window.location.href = "/cart/" + variant().id + ":" + state.size;
    });
  }

  render();

  // ---------- reviews: sort + filtro sobre los datos reales extraidos ----------
  var REVIEWS = DATA.reviews || [];
  var revList = document.querySelector("[data-up-rev-list]");
  var sortSel = document.querySelector("[data-up-rev-sort]");
  var photoFilter = document.querySelector("[data-up-rev-photos]");
  function renderReviews() {
    if (!revList) return;
    var items = REVIEWS.slice();
    if (photoFilter && photoFilter.checked) items = items.filter(function (r) { return r.imgs && r.imgs.length; });
    var starBoxes = [].slice.call(document.querySelectorAll("[data-up-rev-star]:checked")).map(function (c) { return c.value; });
    if (starBoxes.length) items = items.filter(function () { return starBoxes.indexOf("5") !== -1; }); // todas las reseñas reales son 5 estrellas
    var mode = sortSel ? sortSel.value : "recent";
    if (mode === "photos") items.sort(function (a, b) { return (b.imgs.length || 0) - (a.imgs.length || 0); });
    revList.innerHTML = items.map(function (r) {
      var imgs = (r.imgs || []).filter(function (u) { return !/broken-image/.test(u); });
      var photos = imgs.slice(0, 3).map(function (u) { return '<img src="' + u + '" alt="Photo by ' + r.name + '" loading="lazy">'; }).join("");
      var initials = r.name.split(" ").map(function (w) { return w[0]; }).join("").slice(0, 2).toUpperCase();
      return '<div class="up-rev-card">' +
        '<div class="panel">' +
          '<div class="avatar">' + initials + '</div>' +
          '<div class="pname">' + r.name + '</div>' +
          (r.verified ? '<div class="pverified">&#10003; Verified Buyer</div>' : "") +
          '<div class="previewing">Reviewing<br><b>' + DATA.productTitle + '</b></div>' +
          '<div class="precommend">&#10003; I recommend this product</div>' +
        '</div>' +
        '<div class="mid">' +
          '<div class="top"><span class="up-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span><span class="date">' + r.date + '</span></div>' +
          '<div class="title">' + r.title + '</div>' +
          '<div class="body">' + r.body + '</div>' +
          '<div class="helpful">Was this helpful? <button type="button">&#128077; ' + (r.helpfulUp || "0") + '</button><button type="button">&#128078; ' + (r.helpfulDown || "0") + '</button></div>' +
        '</div>' +
        (photos ? '<div class="photos">' + photos + '</div>' : '<div class="photos"></div>') +
        "</div>";
    }).join("");
  }
  var filtersBtn = document.querySelector("[data-up-rev-filters-btn]");
  var filtersPanel = document.querySelector("[data-up-rev-filters-panel]");
  if (filtersBtn && filtersPanel) filtersBtn.addEventListener("click", function () { filtersPanel.hidden = !filtersPanel.hidden; });
  document.querySelectorAll("[data-up-rev-star]").forEach(function (cb) { cb.addEventListener("change", renderReviews); });

  // tira de fotos reales junto a "100% would recommend"
  var stripEl = document.querySelector("[data-up-rev-photostrip]");
  if (stripEl) {
    var stripImgs = [];
    REVIEWS.forEach(function (r) { (r.imgs || []).forEach(function (u) { if (stripImgs.length < 8) stripImgs.push(u); }); });
    stripEl.innerHTML = stripImgs.map(function (u) { return '<img src="' + u + '" alt="Customer photo" loading="lazy">'; }).join("");
  }

  // tabs Reviews / Questions (Questions = estado vacío real de Okendo, sin backend de preguntas)
  var tabs = document.querySelectorAll("[data-up-rev-tab]");
  var revListWrap = document.querySelector("[data-up-rev-list]");
  var questionsEl = document.querySelector("[data-up-rev-questions]");
  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      tabs.forEach(function (t) { t.classList.remove("active"); });
      tab.classList.add("active");
      var isQuestions = tab.dataset.upRevTab === "questions";
      if (revListWrap) revListWrap.hidden = isQuestions;
      if (questionsEl) questionsEl.hidden = !isQuestions;
    });
  });
  if (sortSel) sortSel.addEventListener("change", renderReviews);
  if (photoFilter) photoFilter.addEventListener("change", renderReviews);
  renderReviews();

  // ---------- accordions nativos (details/summary ya funcionan sin JS) ----------
})();
